var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3 13.6656V18.5484H14.1714C11.0417 18.5484 8.50469 21.0855 8.50469 24.2152V64.8328H2.6625C1.19203 64.8328 0 63.6408 0 62.1703V4.59219C0 3.12172 1.19203 1.92969 2.6625 1.92969H29.1672C30.0922 1.92969 30.9344 2.46406 31.3266 3.30156L34.9344 11.0031H65.6375C67.108 11.0031 68.3 12.1952 68.3 13.6656Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3374 23.2354H15.7484C14.3375 23.2354 13.1921 24.3807 13.1921 25.7916V75.4057C13.1921 76.876 14.3843 78.0682 15.8546 78.0682H77.3374C78.8078 78.0682 80 76.876 80 75.4057V25.8979C80 24.4275 78.8078 23.2354 77.3374 23.2354ZM33.7687 45.851C34.6828 44.9353 36.1671 44.9353 37.0828 45.851L44.2531 53.0213V33.0932C44.2531 31.7994 45.3015 30.7494 46.5968 30.7494C47.8906 30.7494 48.9406 31.7994 48.9406 33.0932V53.0213L56.1109 45.851C57.0249 44.9353 58.5093 44.9353 59.425 45.851C60.3406 46.7666 60.3406 48.2494 59.425 49.165C59.425 49.165 48.6017 59.9525 48.239 60.3494C47.3818 61.2875 45.7806 61.2286 44.939 60.3369L33.7687 49.165C32.8531 48.2494 32.8531 46.7666 33.7687 45.851ZM65.6812 68.2103C65.6812 69.5041 64.6328 70.5541 63.3374 70.5541H29.8546C28.5609 70.5541 27.5109 69.5041 27.5109 68.2103V62.9166C27.5109 61.6213 28.5609 60.5728 29.8546 60.5728C31.15 60.5728 32.1984 61.6213 32.1984 62.9166V65.8666H60.9937V62.9166C60.9937 61.6213 62.0437 60.5728 63.3374 60.5728C64.6328 60.5728 65.6812 61.6213 65.6812 62.9166V68.2103Z",
    fill: "#FE2C55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat2);
export default __webpack_public_path__ + "static/media/feat2.bb9a4f0faaa1c2ffc51d462023f52d92.svg";
export { ForwardRef as ReactComponent };